export default "__VITE_ASSET__5ElAkNwG__"